import { addTableHeader, breakWord, drawBody } from "../InvoiceGeneratorUtils";
import { IGeneratePDF_SURAT_JALAN } from "../generateInvoice.type";

const PDF_SURAT_JALAN = (data: IGeneratePDF_SURAT_JALAN) => {
  const header = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 150,
      },
    },
    {
      title: "SAT",
      style: {
        width: 30,
      },
    },
    {
      title: "QTY",
      style: {
        width: 22,
      },
    },
  ];

  // Data Table
  const dataTable: any[] = [];
  data.invoice.forEach((item, index) => {
    let temp: any[] = [];
    temp.push(index + 1); // No
    temp.push(item.name); // Nama Barang
    temp.push(item.unitType); // Satuan
    temp.push(item.qty); // Qty
    dataTable.push(temp);
    temp = [];
  });

  // Minimum Rows
  for (let i = dataTable.length; i < 12; i++) {
    let temp: any[] = [];
    temp.push(" ");
    dataTable.push(temp);
  }

  const print = (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;
    const colorBlack = "#000000";
    const colorGray = "#4d4e53";
    const fieldTextSize = 10;
    const subLineHeight = 4;
    const tdWidth = (doc.getPageWidth() - 20) / header.length;
    const headerTextSize = 20;
    const labelTextSize = 12;
    const lineHeight = 6;

    const pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header,
      dataTable,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };

    // Header Invoice
    // doc.addImage(data.logo, "PNG", 10, 10, 22, 22);
    doc.setFontSize(pdfConfig.headerTextSize);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, currentHeight, `${data.companyName}`);
    doc.setFontSize(12);
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      `Tanggal : ${data.date} `,
      "right"
    );
    doc.setFontSize(12);
    pdfConfig.currentHeight += breakWord(
      `Customer: ${data?.customerName || ""}`,
      doc,
      pdfConfig.currentHeight + 7,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += breakWord(
      data?.customerPhone || "",
      doc,
      pdfConfig.currentHeight + 7 + 5,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += breakWord(
      data?.customerAddress || "",
      doc,
      pdfConfig.currentHeight + 7 + 5 + 5,
      pdfConfig.docWidth - 12
    );
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyAddress}`);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyPhone}`);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyLocation}`);
    pdfConfig.currentHeight += 5;
    // if (data?.pre_order_number) {
    //   doc.text(
    //     pdfConfig.docWidth - 12,
    //     pdfConfig.currentHeight,
    //     data?.pre_order_number || "",
    //     "right"
    //   );
    //   pdfConfig.currentHeight += 5;
    // } else {
    //   pdfConfig.currentHeight += 2;
    // }
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setFontSize(17);
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight + 2,
    //   `# ${data.invoiceNumber}`,
    //   "right"
    // );
    doc.setFontSize(12);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight + 2, `SURAT JALAN`);
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setTextColor(pdfConfig.colorGray);
    pdfConfig.currentHeight += pdfConfig.subLineHeight;
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 1;

    // Table Header
    addTableHeader({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Body
    doc.setFontSize(pdfConfig.fieldTextSize + 1);
    drawBody({ doc: doc, config: pdfConfig });
    // doc.line(
    //   10,
    //   pdfConfig.currentHeight,
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight
    // );

    // Invoice Tanda Terima
    // doc.setFontSize(pdfConfig.fieldTextSize);
    // pdfConfig.currentHeight += 21;
    // doc.text(10, pdfConfig.currentHeight, "PENERIMA,");
    // doc.line(
    //   10,
    //   pdfConfig.currentHeight + 15,
    //   50,
    //   pdfConfig.currentHeight + 15
    // );
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight,
    //   "HORMAT KAMI,",
    //   "right"
    // );
    // doc.line(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight + 15,
    //   pdfConfig.docWidth - 50,
    //   pdfConfig.currentHeight + 15
    // );
  };

  return { print };
};

export { PDF_SURAT_JALAN };
